<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import Dropdown from '@/Components/Dropdown/Dropdown.vue';
import DropdownLink from '@/Components/Dropdown/DropdownLink.vue';
import IconLanguage from '@/Components/Icons/IconLanguage.vue';

const page = usePage();

const currentLocale = computed(() => page.props.locale || 'en');

const availableLocales = computed(() => {
  const locales = page.props.locales || {};

  return Object.entries(locales).map(([code, data]) => ({
    code,
    name: data.name,
    native: data.native,
    url: data.url
  }));
});

const currentLocaleData = computed(() => {
  return (
    availableLocales.value.find(
      (locale) => locale.code === currentLocale.value
    ) || {
      code: currentLocale.value,
      native: currentLocale.value.toUpperCase()
    }
  );
});
</script>

<template>
  <Dropdown align="right" :content-classes="['py-1', 'bg-foreground']">
    <template #trigger>
      <div class="flex items-center gap-2">
        <IconLanguage :size="20" />
        <span class="text-sm font-medium uppercase">
          {{ currentLocaleData.native }}
        </span>
      </div>
    </template>

    <template #content>
      <DropdownLink
        v-for="locale in availableLocales"
        :key="locale.code"
        :href="locale.url"
        as="a"
        :classes="locale.code === currentLocale ? 'font-bold' : ''"
      >
        {{ locale.native }}
      </DropdownLink>
    </template>
  </Dropdown>
</template>
